
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/product-exchange-return-policy",
      function () {
        return require("private-next-pages/info/product-exchange-return-policy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/product-exchange-return-policy"])
      });
    }
  